import * as React from "react";
import { COLOR } from "../utils/variables";
export var Card = function (props) {
    var containerStyle = {
        boxShadow: "0px 3px 6px ".concat(COLOR.SHADOW),
        borderRadius: 5,
        overflow: "hidden",
        margin: 5,
    };
    var headerStyle = {
        backgroundColor: props.headerBackgroundColor ? props.headerBackgroundColor : COLOR.PRIMARY,
        color: props.headerTextColor ? props.headerTextColor : COLOR.WHITE,
        fontSize: "18px",
        fontWeight: 500,
        padding: "10px 7px",
    };
    var bodyStyle = {
        backgroundColor: props.bodyBackgroundColor ? props.bodyBackgroundColor : COLOR.WHITE,
        color: props.bodyTextColor ? props.bodyTextColor : COLOR.BLACK,
        padding: 7,
        fontSize: "15px",
    };
    return (React.createElement("div", { style: containerStyle },
        props.headerTitle &&
            React.createElement("div", { style: headerStyle }, props.headerTitle),
        React.createElement("div", { style: bodyStyle }, props.children)));
};
export default Card;
//# sourceMappingURL=index.js.map